function initMainNav() {
    const mainNav = document.querySelector('.main-nav')
    if (!mainNav) return
    const firstBlockList = mainNav.querySelector('.main-nav__block-list--first-lvl')
    const mediaRequest = window.matchMedia('(max-width: 1250px)')

    document.addEventListener('click', (event) => {
        if (event.target.closest('.main-nav')) {
            if (event.target.closest('.main-nav__menu')) {
                firstBlockList.classList.toggle('active')
            }
        } else {
            firstBlockList.classList.remove('active')
        }
    })

    if (mediaRequest.matches) {
        mainNav.addEventListener('click', (event) => {
            if (event.target.closest('.main-nav__li')) {
                const li = event.target.closest('.main-nav__li')
                const blockList = li.querySelector('.main-nav__block-list')
                li.classList.toggle('active')
                if (blockList) $(blockList).slideToggle()
            }
        })   
    }
}